import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AB_API_GETACCOUNTDETAILS } from '../constants';
import { ApiClientService, ApiResponse } from './api-client.service';
import { IProduct } from '../../dashboard/services/account-overview.service';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

interface AccountDetailsResponse extends ApiResponse {
  bankAccounts: IProduct[];
}

export enum PortfolioLevel {
  Selected,
  All
}

@Injectable({
  providedIn: 'root'
})
export class AccountDetailsService extends ApiClientService {
  private _formLogin = false;
  private isLoading = false;
  private accountForTransfer = new ReplaySubject<{ [key: string]: IProduct }>(
    null
  );
  private accountForTransferIsLoaded = false;

  get fromLogin() {
    const value = this._formLogin;
    if (this._formLogin) {
      this._formLogin = false;
    }

    return value;
  }

  constructor(http: HttpClient) {
    super(http, AB_API_GETACCOUNTDETAILS);
  }

  setFromLogin() {
    this._formLogin = true;
  }

  getDetails(): Observable<{ [key: string]: IProduct }> {
    return this.getWithoutLoader().pipe(
      map((response: AccountDetailsResponse) => {
        const responseObject: { [key: string]: IProduct } = {};
        response.bankAccounts.forEach(account => {
          responseObject[account.accountId] = account;
        });

        return responseObject;
      })
    );
  }

  getAccountForTransfer() {
    if (!this.accountForTransferIsLoaded && !this.isLoading) {
      this.isLoading = true;
      this.getDetails().subscribe(
        result => {
          this.accountForTransfer.next(result);
          this.accountForTransferIsLoaded = true;
          this.isLoading = false;
        },
        () => (this.isLoading = false),
        () => (this.isLoading = false)
      );
    }

    return this.accountForTransfer.asObservable();
  }

  clearAccountForTransfer() {
    this.accountForTransferIsLoaded = false;
    this.accountForTransfer.complete();
    this.accountForTransfer = new ReplaySubject<{ [key: string]: IProduct }>(
      null
    );
  }
}
